<template>
    <div class="burger1Back" @click="closeBurger()"> 
        <div class="burger1" @click.stop>
            <div class="closeBurger" @click="closeBurger()">
                <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"/>
                </svg>
            </div>
            <div class="burger1__top">
                <img src="@/assets/icons/logo.svg"/>
                <img src="@/assets/icons/logoText.svg"/>
                <div class="burger__top__userinfo">
                    <img :src="userInfo.image" alt="curator image" v-if="userInfo.image" @click="openYes = true" />
                    <img src="https://admin.mentorme.kz/adminlte-assets/dist/img/default-avatar.png" alt="curator image" v-else>
                    <p class="burger__top__userinfo__userName">{{userInfo?.name}}</p>
                    <p class="burger__top__userinfo__userSpec" v-if="userInfo?.study_degree">{{userInfo?.study_degree?.title }}</p>
                    <p class="burger__top__userinfo__userSpec" v-else>{{userInfo?.role?.name }}</p>
                </div>
                <div class="burger1__top__bot">
                    <img src="@/assets/icons/basket.svg"/>
                    <img src="@/assets/icons/bell.svg" @click="triggerNotifications()"/>
                </div>  
            </div>
            <div class="burger1__list">
                <div class="burger1__list__in" v-if="$store.state.role !== 'curator' && $store.state.role !== 'supervisor' && $store.state.role !== 'expert' && $store.state.role !== 'chief'" v-for="item in visibleUserTabs" :key="item.route" @click="guestRouteFilter(item.route)">
                    <div class="line"></div>
                    <p :class="{choosen : $route.path == item.route || $route.path == item?.route1}">
                        {{ item.name }}
                        <span v-if="item.badge === 'messenger' && unreadMessages > 0" class="burger1__badge">
                            {{ unreadMessages > 99 ? '99+' : unreadMessages }}
                        </span>
                    </p>
                </div>

                <div class="burger1__list__in" v-if="$store.state.role === 'curator'" v-for="item in tabsCurator" :key="item" @click="guestRouteFilter(item.route)">
                    <div class="line"></div>
                    <p :class="{choosen : $route.path == item.route || $route.path == item?.route1}">{{ item.name }}</p>
                </div>

                <div class="burger1__list__in" v-if="$store.state.role === 'supervisor'" v-for="item in tabsSupervisor" :key="item" @click="guestRouteFilter(item.route)">
                    <div class="line"></div>
                    <p :class="{choosen : $route.path == item.route || $route.path == item?.route1}">{{ item.name }}</p>
                </div>

                <div class="burger1__list__in" v-if="$store.state.role === 'chief'" v-for="item in tabsChief" :key="item" @click="guestRouteFilter(item.route)">
                    <div class="line"></div>
                    <p :class="{choosen : $route.path == item.route || $route.path == item?.route1}">{{ item.name }}</p>
                </div>

                <div class="burger1__list__in" v-if="$store.state.role === 'expert'" v-for="item in tabsExpert" :key="item" @click="guestRouteFilter(item.route)">
                    <div class="line"></div>
                    <p :class="{choosen : $route.path == item.route || $route.path == item?.route1}">{{ item.name }}</p>
                </div>

                <div class="burger1__list__in" @click="leaveAccount()">
                    <div class="line"></div>
                    <p>Выйти</p>
                </div>
            </div>
        </div>
    </div>
    <div class="yesornoModalBack" v-if="openYes">
        <div class="yesornoModal">
            <div class="yesornoModal__left">
                <p>Выберите действие</p>
                <img src="@/assets/icons/exit.svg" @click="openYes = false"/>
            </div>
            <div class="yesornoModal__buttons">
                <label class="yesornoModal__buttons__redactor" for="imageWeb">
                    Изменить
                    <input type="file" id="imageWeb" accept="image/png, image/jpeg" @change="handleFileChange" style="display: none;" />
                </label>
                <span @click="deleteImage()" style="background-color: red;">Удалить</span>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import GuestModal from '@/components/guest/modal.vue'
import axios from "axios";
import { EventBus } from '@/eventBus'
export default {
    components: {
        GuestModal
    },
    data(){
        return{
            isCurator: true,
            openYes: false,
            tabsSupervisor: [
                {
                    img: 'tab_1',
                    name: 'Личный кабинет',
                    route:'/supervisor'
                },
                {
                    img: 'tabc_3',
                    name: 'Пользователи',
                    route:'/supervisor/users'
                },
                {
                    img: 'tab_8',
                    name: 'Платформа',
                    route:'/supervisor/platform'
                },
                {
                    img: 'tabc_4',
                    name: 'Уведомления',
                    route: '/curator/notifications'
                },
            ],
            tabsChief: [
                {
                    img: 'tab_1',
                    name: 'Личный кабинет',
                    route:'/supervisor'
                },
                {
                    img: 'tabc_3',
                    name: 'Пользователи',
                    route:'/supervisor/users'
                },
                {
                    img: 'wait',
                    name: 'Заявки',
                    route:'/chief/requests'
                },
                {
                    img: 'tab_8',
                    name: 'Платформа',
                    route:'/supervisor/platform'
                },
                {
                    img: 'tabc_4',
                    name: 'Уведомления',
                    route: '/curator/notifications'
                },
            ],
            tabsCurator: [
                {
                    img: 'tab_1',
                    name: 'Личный кабинет',
                    route: '/curator'
                },
                {
                    img: 'tabc_2',
                    name: 'Программы',
                    route: '/curator/programs',
                },
                {
                    img: 'tabc_3',
                    name: 'Пользователи',
                    route: '/curator/users'
                },
                {
                    img: 'tabc_4',
                    name: 'Уведомления',
                    route: '/curator/notifications'
                },
            ],
            tabsExpert: [
                {
                    img: 'tab_1',
                    name: 'Личный кабинет',
                    route: '/curator'
                },
                {
                    img: 'tabc_2',
                    name: 'Программы',
                    route: '/curator/programs',
                },
                {
                    img: 'wait',
                    name: 'Заявки',
                    route: '/expert/requests',
                },
                {
                    img: 'tabc_3',
                    name: 'Пользователи',
                    route: '/curator/users'
                },
                {
                    img: 'tabc_4',
                    name: 'Уведомления',
                    route: '/curator/notifications'
                },
            ],
            tabs:[
                {
                    img: 'tab_1',
                    name: 'Личный кабинет',
                    route: '/platform',
                    requiresApprovedPrograms: true,
                },
                {
                    img: 'tab_2',
                    name: 'Поиск программ',
                    route: '/programs',
                    route1: '/programs/1',
                },
                {
                    img: 'tab_3',
                    name: 'Избранное',
                    route: '/favourites'
                },
                {
                    img: 'tab_4',
                    name: 'Поступление',
                    route: '/platform/admission'
                },
                {
                    img: 'tab_5',
                    name: 'Международные гранты',
                    route: '/platform/intGrants',
                    hidden: false
                },
                {
                    img: 'tab_6',
                    name: 'Языковая и тест. школа',
                    route: '/platform/schools'
                },
                {
                    img: 'tab_10',
                    name: 'Сообщения',
                    route: '/platform/messages',
                    badge: 'messenger',
                },
                {
                    img: 'tab_9',
                    name: 'Премиум опции',
                    route: '/platform/premium'
                },
                {
                    img: 'tab_7',
                    name: 'Полезное',
                    route: '/platform/useful'
                },
            ],
            news: [
                {
                    name: 'Добавлено 120 новых учреждений'
                },
                {
                    name: 'Добавлено 5 новых занятий'
                },
                {
                    name: 'Добавлено 5 новых занятий'
                },
            ]
        }
    },
    computed:{
        ...mapGetters(["userInfo"]),
        /** Непрочитанное в переписке: считает store, здесь только показываем. */
        unreadMessages() {
            return this.$store.state.messenger?.unread || 0;
        },
        visibleUserTabs() {
            return this.tabs.filter((tab) => {
                if (tab.hidden) return false;
                if (
                    tab.requiresApprovedPrograms &&
                    this.$store.state.role === 'user' &&
                    !this.$store.state.hasApprovedPrograms
                ) {
                    return false;
                }
                return true;
            });
        },
    },
    methods: {
        ...mapActions(["logoutUser", "toggleBlock"]),
        triggerNotifications() {
            EventBus.emit('open-notifications')
        },
        closeBurger(){
            this.$emit('closeModal')
        },
        leaveAccount() {
            this.logoutUser();
            toast("Вы вышли с аккаунта.");
            this.$router.push('/')
        },
        guestRouteFilter(path) {
            const allowedForGuest = [
                '/platform',
                '/programs',
                '/platform/intGrants',
                '/platform/schools',
                '/platform/premium',
                '/platform/useful'
            ];
            const blockedForGuest = [
                '/favourites',
                '/platform/admission'
            ];

            if (this.$store.state.role === 'guest') {
                if (allowedForGuest.includes(path)) {
                    this.toggleBlock(false);
                    this.$router.push(path);
                } else if (blockedForGuest.includes(path)) {
                    this.toggleBlock(true);
                } else {
                    this.toggleBlock(true);
                }
                this.$emit('closeModal')
            } else {
                this.toggleBlock(false);
                this.$router.push(path);
                this.$emit('closeModal')
            }
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.imagePreview = URL.createObjectURL(file);
                this.imageForSend= file;
                const formData = new FormData();
                formData.append('image',  this.imageForSend);
                try {
                    axios.post(`/platform/upload-image`, formData, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    });
                    toast.success('Успешно обновлено!')
                    this.originalUser = { ...this.editableUser };
                    this.openYes = false;
                    setTimeout(() => {
                        this.$store.dispatch('requestUser');
                    }, 1000);
                } catch (response) {
                    toast.error(response.response.data.message);
                }
            }
        },
        deleteImage(){
            this.imagePreview = '';
            this.imageForSend = '';
            try {
                axios.get(`/platform/remove-image`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                });
                toast.success('Успешно удалено!')
                this.originalUser = { ...this.editableUser };
                this.openYes = false;
                setTimeout(() => {
                    this.$store.dispatch('requestUser');
                }, 1000);
            } catch (response) {
                toast.error(response.response.data.message);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.yesornoModalBack{
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #0000004D;
    z-index: 1002;
    display: flex;
    justify-content: center;
    align-items: center;
}
.yesornoModal{
    background: white;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: fit-content;
    padding: 20px;
    align-items: center;
    border-radius: 15px;
    width: 90%;
    position: relative;
    &__left{
        display: flex;
        width: 100%;
        justify-content: space-between;
        img{
            width: 15px;
            cursor: pointer;
            aspect-ratio: 1;
            filter: brightness(0) saturate(100%) invert(31%) sepia(98%) saturate(7098%) hue-rotate(355deg) brightness(98%) contrast(118%);
        }
    }
    &__buttons{
        display: flex;
        width: 100%;
        gap: 20px;
        align-items: center;
        flex-direction: column;
        &__redactor, span{
            padding: 10px 20px;
            cursor: pointer;
            border: none;
            background-color: #11415D;
            color: white;
            border-radius: 10px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.line{
    border: 1px solid rgba(255,255,255, 0.1);
}
    .burger1Back{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
    }
    .burger1{
        width: 80%;
        max-width: 270px;
        height: 100vh;
        background: linear-gradient(180deg, #11415dca 0px, #2489c3cf 500px);
        padding: 70px 16px;
        display: flex;
        flex-direction: column;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        backdrop-filter: blur(3px);
        &__top{
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
            &__bot{
                display: flex;
                gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
                img{
                    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7470%) hue-rotate(290deg) brightness(112%) contrast(91%);
                }
            }
        }
        &__list{
            display: flex;
            flex-direction: column;
            gap: 10px;
            &__in{
                display: flex;
                flex-direction: column;
                gap: 10px;
                font-size: min(max(20px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
                color: rgba(255, 255, 255, 0.8);

                .choosen {
                  font-weight: 700;
                  color: white;
                }
            }

            // Непрочитанное — рядом с названием пункта, а не отдельной строкой:
            // меню на телефоне и так занимает весь экран.
            &__badge {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                min-width: 22px;
                height: 22px;
                margin-left: 8px;
                padding: 0 6px;
                border-radius: 999px;
                background: #ff8800;
                color: #fff;
                font-size: 12px;
                font-weight: 700;
                vertical-align: middle;
            }
        }
    }
</style>